import { call, put, takeLatest, select } from "redux-saga/effects";
import { downloadSuccess, downloadFailure, rolesTypes, fetchSuccess, fetchFailure } from "../actions/roles";
import { fetchRolesEndPoint } from "../../configuration";
import { getRandomUUID } from "../../Token";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
function* fetchRolesSaga(action) {
  try {
    const filters = action.payload;
    const user = yield select((state) => state.auth.user);
    const response = yield call(fetchRolesAPI,filters, user);
    yield put(fetchSuccess([...response]));
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}
async function fetchRolesAPI(filters,user){
  try {
    let activeSession = sessionStorage.getItem("activeSession");
    if(activeSession){
      activeSession = JSON.parse(activeSession);
    }
    const response = await fetch(fetchRolesEndPoint(), {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      method: "POST",
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        currentrole: activeSession?.role?.name,
        filter: { $sort: [{ field: "name", order: filters!==undefined? `${filters?.sort[0]?.order}`: "asc", $selection: `${filters?.name}`, }] },
      }),
    });
    const data = await response.json();
    let roles = [];
    const filteredData = data?.filter((alert) => 
    !filters?.name ||
    filters?.name?.some((name) => alert?.name?.includes(name))
    );
    roles= filteredData?.length>0? filteredData:data;
    return roles;
  } catch (error) {
    return [];
  }
}

function* downloadSaga() {
  try {
    const response = yield call(apiDownload);
    JSONToCSVDownload(rolesCSVFormat(response), "rolesList_download.csv");
    yield put(downloadSuccess([...response]));
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const rolesCSVFormat = (jsonArray) => {

  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    id: json?.id,
    name: json?.name,
    PermissionsSpecial: json?.permissions,
    description: json?.description,
    createdon: json?.createdon,
    lastupdated: json?.lastupdated
  }));
};

function apiDownload() {
  return fetch(fetchRolesEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: 'POST',
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    })
  }).then((response) => response.json());
}

export function* RolesDownloadSaga() {
  yield takeLatest(rolesTypes.DOWNLOAD_REQUEST, downloadSaga);
}

export  function* RolesFetchSaga() {
  yield takeLatest(rolesTypes.FETCH_REQUEST, fetchRolesSaga);
}